import { render } from "./RiProdcategory28.vue?vue&type=template&id=0b46e5e8"
import script from "./RiProdcategory28.vue?vue&type=script&lang=js"
export * from "./RiProdcategory28.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory28.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b46e5e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b46e5e8', __exports__)) {
    api.reload('0b46e5e8', __exports__)
  }
  
  module.hot.accept("./RiProdcategory28.vue?vue&type=template&id=0b46e5e8", () => {
    api.rerender('0b46e5e8', render)
  })

}


export default __exports__